import 'regenerator-runtime/runtime'
import axios from 'axios';
import _ from "lodash";
import Vue from 'vue';
import VueResource from 'vue-resource';
Vue.use(VueResource);


export default {

    global_vars: {        
        app_version: "22.0707",    
        alla_indikatorer: [],
        forvaltningsnamn: [],
        franvaro: [],
        anstallda: [],
    },

    methods: {

        SendMySQLquery: async function (MySQL_string) {

            // I console visar vi MySQL-frågesträngen som ska skickas till databasen
            //console.log("SendMySQLquery(" + MySQL_string + ")");
            // Sätt variabler för att hålla filnamnet på den php-fil vi ska använda och för den data som ska skickas till den php-filen
            var ajaxurl = 'https://www.krisindikatorer.se/MySQLq.php', data = { 'MySQL_string': MySQL_string };
            // Skicka data till php-filen och invänta svar som sätts i variabeln 'response'
            return $.post(ajaxurl, data, function (response) {
                                
                //console.log("SendMySQLquery: response: " + response);
             
            });        
        },


    }

}



// WEBPACK FOOTER //
// ./src/global_resources.js